const store: Record<string, any> = {};
export const useData = () => {
  return {
    get: (key: string) => store[key],
    set: (key: string, value: any) => (store[key] = value),
    remove: (key: string) => delete store[key],
    getAll: () => store,
  };
};
